<div ngbDropdown class="">
  <div
    class="abd border btn btn-icon btn-sm"
    id="dropdownBasic1"
    ngbDropdownToggle
    [ngClass]="{
      'border-warning': same_state === false ||  status === null,
      'border-success':
        (valuePermission !== true && same_state === true && open === true) ||(valuePermission === true && open === true) || status === true,

      'border-gray-400': valuePermission === null && same_state === true && open === false && isDirty===false,
      'border-danger':(valuePermission === false && open === false) || (same_state === true && open === false) && (valuePermission !== false || (valuePermission === null && isDirty !== false)) || status === false
    }"
    data-kt-menu-trigger="{default: 'click'}"
    data-kt-menu-placement="bottom-end"
    >

    <!-- 'border-danger': valuePermission === false && (open === false || status === false) || valuePermission === true && (same_state === true && open === false) || valuePermission === null && (same_state === true && open === false && isDirty !== false) || status === false, -->
  <!-- 'border-danger':
  (valuePermission === false && open === false) || (valuePermission !== false && same_state === true && open === false ) || status===false, -->

    <ng-container *ngIf="valuePermission === false">
      <span
        [inlineSVG]="'./assets/media/svg/general/forbid.svg'"
        [ngClass]="{
          'svg-color-warning': same_state === false,
          'svg-color-green': same_state === true && open === true,
          'svg-color-red': open === false || status === false
        }"
        class="svg-icon theme-light-hide"
      ></span>
    </ng-container>
    <ng-container *ngIf="valuePermission === true">
      <span
        [inlineSVG]="'./assets/media/svg/general/checkmark.svg'"
        [ngClass]="{
          'svg-color-warning': same_state === false,
          'svg-color-green': open === true || status === true,
          'svg-color-red': same_state === true && open === false
        }"
        class="svg-icon theme-dark-hide"
      ></span>
    </ng-container>
    <ng-container *ngIf="valuePermission === null">
      <i
        [ngClass]="{
          'text-warning': same_state === false || status === null,
          'text-success': same_state === true && open === true,
          'text-danger': same_state === true && open === false && isDirty !== false,
          'text-gray-400':same_state === true && open === false && isDirty===false
        }"
        class="bi bi-three-dots fs-3"
      ></i>
    </ng-container>
  </div>

  <div ngbDropdownMenu aria-labelledby="dropdownBasic1" data-kt-menu="true">
    <div
      ngbDropdownItem
      class="menu-item my-0"
      *ngIf="valuePermission !== true"
    >
      <a class="menu-link py-2" (click)="writeValue(true)">
        <span class="menu-icon" data-kt-element="icon">
          <span
            [inlineSVG]="'./assets/media/svg/general/checkmark.svg'"
            class="svg-icon svg-color-green svg-icon-3"
          ></span>
        </span>
        <span class="menu-title" translate>Autoriser</span>
      </a>
    </div>

    <div
      ngbDropdownItem
      class="menu-item my-0"
      *ngIf="valuePermission !== false"
    >
      <a class="menu-link py-2" (click)="writeValue(false)">
        <span class="menu-icon" data-kt-element="icon">
          <span
            [inlineSVG]="'./assets/media/svg/general/forbid.svg'"
            class="svg-icon svg-color-red svg-icon-3"
          ></span>
        </span>
        <span class="menu-title" translate>Exclure</span>
      </a>
    </div>

    <div
      ngbDropdownItem
      class="menu-item my-0"
      *ngIf="valuePermission !== null"
    >
      <a (click)="writeValue(null)" class="menu-link py-2">
        <span class="menu-icon" data-kt-element="icon">
          <span
            [inlineSVG]="'./assets/media/svg/general/cross.svg'"
            class="svg-icon svg-color-red svg-icon-3"
          ></span>
        </span>
        <span class="menu-title" translate>Supprimer</span>
      </a>
    </div>
  </div>
</div>
